import Swiper from 'swiper';

export default {
  name: 'homeSlider',
  //---components
  //---data
  data () {
    return {
      sliderCollection: [],
      isAllSliderImagesLoaded: false,
      autoplayDelay: 5000, //---ms
      animSpeedTime: 500,
      animProgressWidth: 0,
      animClear: false,
      baseSliderImgUrl: ''
    }
  },
  //---hooks
  created: function () {
    for (let index = 0; index < 10; index++) {
      let item = Object.assign({}, {
        imgSrc: require('@/assets/img/src/home/' + (index + 1) + '-min.jpg')
      });
      this.$set(this.sliderCollection, index, item);
    }
  },
  mounted: function () {
    this._initSwiper();
  },
  //---methods
  methods: {
    _initSwiper() {
      let self = this;
      let sliderSwiper = new Swiper('.home-slider__container', {
        loop: true,
        slidesPerView: 1,
        effect: 'slide',
        speed: self.animSpeedTime,
        autoplay: {
          delay: self.autoplayDelay,
          disableOnInteraction: false
        },
        pagination: {
          el: '.home-slider__pagination',
          type: 'bullets',
          clickable: false
        },
        grabCursor: true,
        preloadImages: true,
        //---events
        on: {
          sliderMove: function () {
            self.animClear = true;
            self.animProgressWidth = 0;
          },
          transitionStart: function () {
            self.animClear = true;
            self.animProgressWidth = 0;
          },
          transitionEnd: function () {
            self.animClear = false;
            self.animProgressWidth = 100;
            setTimeout(()=> {
              self.animClear = true;
              self.animProgressWidth = 0
            },self.autoplayDelay)
          },
          imagesReady: function () {
            self.isAllSliderImagesLoaded = true;
          }
        }
      });

      setTimeout(() => {
        sliderSwiper.update()
      }, 0)
    },
  }
}